import { useTranslation } from 'react-i18next'
import { useMediaQuery } from 'usehooks-ts'

import useCustomerMessage from '@entities/User/hooks/useCustomerMessage'

import { useProfileCustomerModal } from '@features/auth'
import { useModalStore } from '@features/modal'


import Button from '@shared/ui/button'

import styles from './styles.module.scss'

interface CustomerMessageProps {
  onCloseCallback?: () => void;
}

export default function CustomerMessage ({
  onCloseCallback,
}: CustomerMessageProps) {
  const { t } = useTranslation('common')
  const isTablet = useMediaQuery('(max-width: 767px)')
  const { closeCustomerMessage } = useCustomerMessage()
  const { closeModal } = useModalStore()
  const { openProfileCustomerModal } = useProfileCustomerModal()
  const { modals } = useModalStore()
  const loginModalCallback = modals.get('loginOrRegister')?.config?.onClose

  const handleRepeat = () => {
    closeModal('customerMessage', true)
    openProfileCustomerModal(() => {
      if (onCloseCallback) {
        onCloseCallback()
      }
    })
  }

  const handleClose = () => {
    closeCustomerMessage()
    if (loginModalCallback) {
      loginModalCallback()
    }
  }

  return (
    <div className={styles['customer-message']}>
      <Button size={isTablet ? 'medium' : 'large'} onClick={handleRepeat}>
        {t('continue')}
      </Button>
      <Button
        theme="grey"
        size={isTablet ? 'medium' : 'large'}
        onClick={handleClose}
      >
        {t('finish')}
      </Button>
    </div>
  )
}
